
export const TemplateOnScreenDisplay = ({ children, className }: { children: React.ReactNode, className?: string }) => {
    return (
        <div className={`w-[193px] h-[241px] flex items-center justify-center overflow-hidden border-2 border-osGrey-4 rounded-[24px] ${className}`}>
            {children}
        </div>
    );
};